import React from 'react';
import { ArrowUp20Filled, ArrowDown20Filled } from '@fluentui/react-icons';
import { ISortableHeaderProps } from '../types/ISortableHeaderProps';
import './SortableHeader.css';

const SortableHeader: React.FC<ISortableHeaderProps> = ({ title, sortDirection, onClick }) => {
    return (
        <div onClick={onClick} className="sortableHeader">
            {title}
            <span className="sortableHeaderTitle">
                {sortDirection === "asc" ? (
                    <ArrowUp20Filled data-testid="arrow-up-icon" />
                ) : (
                    <ArrowDown20Filled data-testid="arrow-down-icon" />
                )}
            </span>
        </div>
    );
};

export default SortableHeader;